<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        show-overflow
        highlight-hover-row
        :data="tableData"
        :height="200"
        :columns="tableColumns"
        :edit-rules="validRules"
        row-key
        size="small"
        auto-resize
        resizable
        border
        :edit-config="{ trigger: 'click', mode: 'row' }"
      >
        <template v-slot:toolbar_form> </template>
        <template v-slot:opt="{ row }">
          <div>
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </div>
        </template>
      </vxe-grid>
      <AddIssues
        ref="addIssues"
        v-if="issuesVisible"
        :visible.sync="issuesVisible"
        :issueType="'B'"
        :title="$l('drawer_label_majorIssues') ||'重大问题选择'"
        @confirm="confirm"
      />
    </div>
  </div>
</template>
<script>
import AddIssues from '../add-issues'
import lodash from 'lodash'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    AddIssues,
  },
  mixins: [EditLoading],
  props: {
    inspectionDefectList: {
      type: Array,
      default: () => [],
    },
    disabled: { type: Boolean, default: false },
    inspectionDetailCode: { type: String, default: '' },
  },

  data() {
    return {
      issuesVisible: false,
      tableData: [],
      formData: { identifyNo: '' },
      validRules: {},

      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'defectIssuesTitle',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          title: this.$l('table_label_majorIssues') || '重大问题',
          formatter: ({ row }) => this.formatIssueTitle(row),
        },

        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          slots: {
            default: 'opt',
          },
          visible: !this.disabled,
        },
      ],
    }
  },
  watch: {
    inspectionDefectList: {
      handler(val) {
        if (val) this.tableData = lodash.cloneDeep(val)
      },
      immediate: true,
    },
  },
  computed: {},

  methods: {
    getTableData() {
      const { tableData } = this.$refs.table.getTableData()
      return tableData.map((row) => {
        return {
          ...row,
        }
      })
    },

    openEditDrawer() {
      this.issuesVisible = true
    },
    formatIssueTitle(row = {}) {
      const title = (row.defectIssuesTitle || '').trim()
      const otherProblemDesc = `${row.otherProblemDesc || ''}`.trim()
      if (title === '其他' && otherProblemDesc) {
        return `${title}：${otherProblemDesc}`
      }
      return title
    },
    async confirm(items) {
      this.loadingOpen()
      await this.$api
        .fabricInspectionDefectSaveApi({
          inspectionDetailCode: this.inspectionDetailCode,
          issueType: 'B',
          inspectionDefectList: items,
        })
        .then((res) => {
          this.loadingClose()
          if (!res) return
          const { status, msg } = res
          if (200 !== status) {
            this.$message({
              showClose: true,
              message: msg || '系统异常',
              type: 'error',
            })
            return
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error('保存失败！')
        })

      this.issuesVisible = false
      this.$emit('reloadIssueList')
    },
    async del(row) {
      await this.delDefectApi({
        inspectionDefectCode: row.inspectionDefectCode,
        issueType: 'B',
        del: true,
      })
    },
    async delDefectApi({ inspectionDefectCode, issueType, del = true }) {
      this.loadingOpen()
      this.$api
        .fabricInspectionDefectDelApi({
          inspectionDefectCode,
          issueType,
          del,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reloadIssueList')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        })
    },
  },
}
</script>
